import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderStatusLabels,
  renderTypePrestation,
  renderUserName,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Button, Space } from "antd";
import { AiFillFileExcel } from "react-icons/ai";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { FilePdfOutlined } from "@ant-design/icons";
import { createXMLString, downloadXML } from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { BsFiletypeXml } from "react-icons/bs";
import { TbFileTypeXml, TbFileTypePdf } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { FcCancel } from "react-icons/fc";
import { UserContext } from "../../../engine/context/User.context";

export const BillsExportFile = ({ type, selectedRowKeys }) => {
  const { t, i18n } = useTranslation();
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const [loading, setLoading] = React.useState(false);

  const exportPDF = () => {
    createAndGet(
      { ids: selectedRowKeys, language: i18n.language },
      `bills/pdfs`,
      true,
      true,
      () => {},
    );
  };

  const exportXML = async bills => {
    try {
      const loggit = await http.post("/logs", {
        baseUrl: "/api/bills",
        action: "export",
        route: "/api/bills/xml",
        ressource: "/api/bills/xml",
        content: {
          billsId: selectedRowKeys,
        },
      });

      const xmlString = createXMLString({
        bills,
      });
      downloadXML(xmlString, "bills.xml");
    } catch (e) {
      console.log(e);
    }
  };

  const exportExcel = async bills => {
    const loggit = await http.post("/logs", {
      baseUrl: "/api/bills",
      action: "export",
      route: "/api/bills/xlxs",
      ressource: "/api/bills/xlxs",
      content: {
        billsId: selectedRowKeys,
      },
    });
    const exportColumns = [
      {
        title: t("BillsExportFile.prestationNumber"),
        dataIndex: "prestationRef",
      },
      {
        title: t("BillsExportFile.billNumber"),
        dataIndex: "bill_number",
      },
      {
        title: t("BillsExportFile.reference"),
        dataIndex: "reference",
      },
      {
        title: t("BillsExportFile.prestationStatus"),
        dataIndex: "status",
      },
      {
        title: t("BillsExportFile.interpreter"),
        dataIndex: "interprete",
      },
      {
        title: t("BillsExportFile.interpreterId"),
        dataIndex: "interpreteId",
      },
      {
        title: t("BillsExportFile.language"),
        dataIndex: "langue",
      },
      {
        title: t("BillsExportFile.totalWithoutVAT"),
        dataIndex: "totalHorsTva",
      },
      {
        title: t("BillsExportFile.prestationCost"),
        dataIndex: "coutPrestation",
      },
      {
        title: t("BillsExportFile.prestationTranches"),
        dataIndex: "tranchesPrestation",
      },
      {
        title: t("BillsExportFile.nightPrestationTranches"),
        dataIndex: "tranchesPrestationNight",
      },
      {
        title: t("BillsExportFile.nightPrestationCost"),
        dataIndex: "coutNight",
      },
      {
        title: t("BillsExportFile.travelCost"),
        dataIndex: "coutTravel",
      },
      {
        title: t("BillsExportFile.kms"),
        dataIndex: "kms",
      },
      {
        title: t("BillsExportFile.totalWithVAT"),
        dataIndex: "totalTTC",
      },
      {
        title: t("BillsExportFile.vat"),
        dataIndex: "tvaAmount",
      },
      {
        title: t("BillsExportFile.centsCorrection"),
        dataIndex: "ctsCorrection",
      },
      {
        title: t("BillsExportFile.startDate"),
        dataIndex: "startDate",
      },
      {
        title: t("BillsExportFile.endDate"),
        dataIndex: "endDate",
      },
      {
        title: t("BillsExportFile.departureLocation"),
        dataIndex: "locationFrom",
      },
      {
        title: t("BillsExportFile.interventionLocation"),
        dataIndex: "location",
      },
      {
        title: t("BillsExportFile.prestationType"),
        dataIndex: "typePrestation",
      },
      {
        title: t("BillsExportFile.institution"),
        dataIndex: "institution",
      },
      {
        title: t("BillsExportFile.outOfCanton"),
        dataIndex: "horsCanton",
      },
      {
        title: t("BillsExportFile.urgent"),
        dataIndex: "urgent",
      },
    ];

    function metersToKilometers(meters) {
      const kilometers = meters / 1000;
      return `${kilometers.toFixed(1)}`;
    }

    const findPresta = (arr, key) => {
      return arr.find(e => e.type === key);
    };

    const mutateData = () => {
      let newArr = [];

      bills.map(bill => {
        const { costParams, costs } = bill;
        bill.prestations.map(presta => {
          let amounts = {
            totalHorsTva: 0,
            totalTTC: 0,
            tvaAmount: 0,
            totalNonAssujeti: 0,
            kms: 0,
            ctsCorrection: 0,
            horsCanton: false,
            urgent: false,
            coutPrestation: 0,
            coutNight: 0,
            coutTravel: 0,
          };
          // TODO migrer grouped Billing by dates
          if (bill.institution.groupedBilling) {
            let ref = bill.costsMultiple.find(
              e => e.prestationId === presta._id,
            );

            if (ref !== undefined) {
              amounts.tvaAmount = costParams.tvaAmount;
              amounts.totalHorsTva = costParams.totalHorsTva;
              amounts.totalTTC = costParams.totalWithTva;

              amounts.totalHorsTva = ref.costParams.total;
              // amounts.kms = metersToKilometers(
              //   ref?.costParams?.driving?.distance?.value || 0,
              // );

              let kms = ref.cost.find(p => p.type === "travel")?.tranches || 0;

              amounts.kms = kms;

              amounts.horsCanton = ref.costParams.isHorsCanton;
              amounts.urgent = ref.costParams.isUrgent;
              amounts.coutPrestation =
                findPresta(ref.cost, "prestation")?.amount || 0;
              amounts.coutNight = findPresta(ref.cost, "night")?.amount || 0;
              amounts.coutTravel = findPresta(ref.cost, "travel")?.amount || 0;
              amounts.tranchesPrestation =
                findPresta(ref.cost, "prestation")?.tranches || 0;
              amounts.tranchesPrestationNight =
                findPresta(ref.cost, "night")?.tranches || 0;
            }
          } else {
            amounts.totalHorsTva = costParams.total;
            amounts.totalTTC = costParams.totalWithTva;
            amounts.tvaAmount = costParams.tvaAmount;
            // amounts.totalNonAssujeti = costParams.;
            // amounts.kms = metersToKilometers(
            //   costParams?.driving?.distance?.value || 0,
            // );

            let kms = costs.find(e => e.type === "travel")?.tranches || 0;

            amounts.kms = kms;

            amounts.ctsCorrection = costParams.roundCorrection;
            amounts.horsCanton = costParams.isHorsCanton;
            amounts.urgent = costParams.isUrgent;
            amounts.coutPrestation =
              findPresta(costs, "prestation")?.amount || 0;
            amounts.coutNight = findPresta(costs, "night")?.amount || 0;
            amounts.coutTravel = findPresta(costs, "travel")?.amount || 0;
            amounts.tranchesPrestation =
              findPresta(costs, "prestation")?.tranches || 0;
            amounts.tranchesPrestationNight =
              findPresta(costs, "night")?.tranches || 0;
          }

          let dates = {
            startDate: null,
            endDate: null,
          };

          let locations = {
            location: "",
            locationFrom: "",
          };

          if (
            presta.interventionFinal.startDate !== null &&
            presta.interventionFinal.endDate !== null
          ) {
            dates.startDate = dayjs(presta.interventionFinal.startDate).format(
              daysJsFormat.full,
            );
            dates.endDate = dayjs(presta.interventionFinal.endDate).format(
              daysJsFormat.full,
            );
          } else {
            dates.startDate = dayjs(presta.intervention.startDate).format(
              daysJsFormat.full,
            );
            dates.endDate = dayjs(presta.intervention.endDate).format(
              daysJsFormat.full,
            );
          }

          if (
            presta.interventionFinal.location !== null &&
            presta.interventionFinal.location !== ""
          ) {
            locations.location = presta.interventionFinal.location;
          } else {
            locations.location = presta.intervention.location;
          }

          if (
            presta.interventionFinal.locationFrom !== null &&
            presta.interventionFinal.locationFrom !== ""
          ) {
            locations.locationFrom = presta.interventionFinal.locationFrom;
          } else {
            locations.locationFrom = presta.intervention.locationFrom;
          }

          newArr.push({
            langue: presta.languages
              .map(p => languagesList().find(e => e.value === p).label)
              .join(" "),
            institution: bill.institution.name,
            status: renderStatusLabels(
              presta.status,
              presta.subStatus,
              presta.isFollow,
            ),
            typePrestation: renderTypePrestation(presta.intervention.type),
            reference: bill.reference,
            bill_number: bill.bill_number,
            prestationRef: presta.reference,
            interprete: renderUserName(presta.interprete),
            interpreteId: presta.interprete._id,
            ...amounts,
            ...dates,
            horsCanton: amounts.horsCanton ? "Oui" : "Non",
            urgent: amounts.urgent ? "Oui" : "Non",
            ...locations,
          });
        });
      });
      return newArr;
    };

    const excel = new Excel();
    excel
      .addSheet("Facturation")
      .addColumns(exportColumns)
      .addDataSource(mutateData())
      .saveAs("facturation.xlsx");
    setLoading(false);
  };

  const getDataBeforeExport = async () => {
    try {
      const billsToExport = await http.post(
        "/bills/exports?advancedCols=true",
        {
          selectedRowKeys,
        },
      );
      return billsToExport.data.bills;
    } catch (e) {
      console.log(e);
    }
  };

  const isDisabled = selectedRowKeys.length === 0;

  return (
    <Space>
      <ActionDropdown loading={loading || isLoading}>
        <a
          loading={loading}
          disabled={isDisabled}
          style={{ opacity: isDisabled ? 0.8 : 1 }}
          onClick={() => {}}
        >
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <TbFileTypeXml color={"red"} size={20} />
          </span>
          {t("BillsExportFile.importCamt")}
        </a>
        <a
          loading={loading}
          disabled={isDisabled}
          style={{ opacity: isDisabled ? 0.8 : 1 }}
          onClick={async () => {
            if (!isDisabled) {
              setLoading(true);
              let bills = await getDataBeforeExport();
              exportExcel(bills);
            }
          }}
        >
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <AiFillFileExcel color={"red"} size={20} />
          </span>
          {t("BillsExportFile.exportXLSX")}
        </a>
        <a
          loading={isLoading}
          disabled={selectedRowKeys.length === 0}
          onClick={() => !isDisabled && exportPDF()}
          style={{ opacity: isDisabled ? 0.8 : 1 }}
        >
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <TbFileTypePdf color={"red"} size={20} />
          </span>
          {t("BillsExportFile.exportPDF")}
        </a>
        <a
          style={{ opacity: isDisabled ? 0.8 : 1 }}
          disabled={selectedRowKeys.length === 0}
          onClick={async () => {
            let bills = await getDataBeforeExport();
            exportXML(bills);
          }}
        >
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <TbFileTypeXml color={"red"} size={20} />
          </span>
          {t("BillsExportFile.exportXML")}
        </a>
      </ActionDropdown>
    </Space>
  );
};
